<script setup>
import { formattedPriceFromCentsWithoutCents as formattedPrice } from "@/util/formatter";
import { computed, defineEmits, toRefs } from "vue";
import { isSessionInPast } from "@/util/date";

const props = defineProps({
  selectedSession: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["preview"]);
const { selectedSession } = toRefs(props);
const displayBasePrice = computed(
  () => !isSessionInPast(selectedSession.value)
);
</script>

<template>
  <div
    v-if="displayBasePrice"
    class="font-bold text-indigo-base text-base"
    data-testid="starting-price-container"
  >
    <p class="font-bold text-indigo-base text-base">
      Starting Price:
      {{ formattedPrice(selectedSession?.base_price_in_cents) }}
    </p>

    <button
      class="underline"
      :class="[
        secondaryColor ? `${secondaryColorClass}` : 'text-university-secondary',
      ]"
      @click="emit('preview', true)"
    >
      See price breakdown here
    </button>
  </div>
</template>

<style scoped></style>
